import styled from "styled-components";

export const MarkdownWrapper = styled.div`
  & > ol {
    margin-bottom: ${({ theme }) => theme.spacing.sm};
    margin-left: 50px;
  }

  & > p {
    margin-bottom: ${({ theme }) => theme.spacing.sm};
  }
`;
